import { Consent } from '@tink/core/src/components/atoms/Icons/Consent';
import { FormattedMessage } from 'react-intl';
import { Spacer } from '@tink/core/src/components/atoms/Spacer/Spacer';
import { Button } from '../../components/atoms/Button/Button';
import { ContentBody } from '../../components/atoms/ContentBody/ContentBody';
import { Footer } from '../../components/atoms/Footer/Footer';
import { H1 } from '../../components/atoms/Heading/Heading';
import { ScreenWrapper } from '../../components/atoms/ScreenWrapper/ScreenWrapper';
import { LegalDisclaimer } from '../../components/molecules/LegalDisclaimer/LegalDisclaimer';
import { Header } from '../../components/organisms/Header/Header';
import { PageView } from '../../models/analytics';
import { CheckmarkText } from '../../components/molecules/CheckmarkText/CheckmarkText';
import { LoadingSpinner } from '../../components/atoms/LoadingSpinner/LoadingSpinner';
import { Stack } from '../../components/atoms/Stack/Stack';
import { Text } from '../../components/atoms/Text/Text';
import { messages } from './messages';

type Props = {
  titles: string[];
  providerName: string;
  isLoading: boolean;
  onClick: () => void;
};

export const ExtendConsentView = ({ titles, providerName, isLoading, onClick }: Props) => (
  <ScreenWrapper>
    <Header addBottomMargin pageView={PageView.EXTEND_CONSENT_SCREEN} onBack={undefined} />

    <ContentBody>
      <Stack justifyContent="center" alignItems="center">
        <Consent />

        <H1 align="center">
          <FormattedMessage {...messages.consentHeader} values={{ providerName }} />
        </H1>

        <Spacer size="xxsmall" />
        <Text mb="xxsmall">
          <FormattedMessage {...messages.consentBody} />
        </Text>

        {titles?.map((consentTitle) => (
          <CheckmarkText key={consentTitle} margin="xsmall">
            {consentTitle}
          </CheckmarkText>
        ))}
      </Stack>

      <Footer stickToBottom>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <Button type="submit" color="primary" variant="contained" onClick={onClick}>
            <FormattedMessage {...messages.confirm} />
          </Button>
        )}
      </Footer>
    </ContentBody>
    <LegalDisclaimer pageView={PageView.EXTEND_CONSENT_SCREEN} />
  </ScreenWrapper>
);
